export default __webpack_public_path__ + "static/rentzy-wordmark-7e413fe5cdebc48a0d0340a0d693bbd5.png";